// extracted by mini-css-extract-plugin
export default {"slide1":"NewsSlide_slide1__Av9cx","slide2":"NewsSlide_slide2__Dv3+y","slide0":"NewsSlide_slide0__zW1xM","slide3":"NewsSlide_slide3__yaIXD"};